import { Api } from '@/service';
import _ from 'lodash'
import Language from './language';
import CountryFlag from 'vue-country-flag'
import ruleI18n from '../rule.i18n'
import reg from '@/reg'
import { VclFacebook } from 'vue-content-loading';

const _i18n_data = {
  get1: {
    EN : () => `"load", "failed"`,
    KO : () => `"로드", "실패"`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};
export default {
  props: ['id', 'only_view'],
  components : { Language, CountryFlag, VclFacebook },
  computed: {
    i18n_data() { return _i18n_data; },
    exception_policy_name() {
      return this.exception_info.detail.file ? _.last(this.exception_info.detail.file.replace('.conf', '').split('/')) : ''
    },
    exception_policy_msg() {
      return this.exception_info.msg ? this.exception_info.msg : ''
    }
  }, // i18n 메세지 변환용.
  data : () => {
    return {
      loading : false,
      detections : [],
      ruleI18n,
      info_xff : false,
      view_split_uri : false,
      view_split_request : false,
      parser_request : false,
      is_error :false,
      model : { uri: '', message : { messages : [], unique_id : "", time_stamp : "" } },
      exception_info :  { detail : {}, agent_id : 0, msg : '' },
      exception_info_modal_add : false,
      exception_info_modal_remove : false,
    }
  },
  methods: {
    add_white : async function(detail, agent_id) {
      let domain = _.last(this.exception_info.detail.file.replace('.conf', '').split('/'))
      let rs = await Api.Manager({ target : 'log', cmd : 'update.exception.add', body : { agent_id : this.exception_info.agent_id, rule_id : this.exception_info.detail.ruleId, domain : domain } })
      if(rs.error) {
        return this.$toastr.e(rs.reason)
      }
      this.$toastr.s("exception updated")
      console.log(this.$parent.$parent, 'reload')
      this.$parent.$emit("reload")
    },
    remove_white : async function(detail, agent_id) {
      let domain = _.last(this.exception_info.detail.file.replace('.conf', '').split('/'))
      let rs = await Api.Manager({ target : 'log', cmd : 'update.exception.remove', body : { agent_id : this.exception_info.agent_id, rule_id : this.exception_info.detail.ruleId, domain : domain } })
      if(rs.error) {
        return this.$toastr.e(rs.reason)
      }
      this.$toastr.s("exception updated")
      this.$parent.$emit("reload")
    },
    split_uri_parser(x, len = window.innerWidth / 15) {
      let total = x.length
      let start = 0
      let rs = ""
      while (total > start) {
        rs += x.substr(start, len) + '\\\r\n'
        start += len
      }
      this.parser_request = true
      return rs.substr(0, rs.length - 4);
    },
    split_uri(uri) { return uri && uri.length > 100 ? this.split_uri_parser(uri) : uri },
    list() { this.$router.push({ name: 'webcastle_log'}); },
    async get({ id } = this.$route.params) {
      this.loading = true
      if(this.id && this.id > 0)  {
        id = this.id
      }
      console.log('detect.detail.vue', 'load item', id);
      try {
        let rs = await Api.Manager_Call('webcastle.log', 'detail', { id : id })
        if(rs.error) { return this.$toastr.e(this.i18n_msg('get1') || '"load", "failed"'); }
        this.model = Object.assign({}, this.model, rs.body);
        this.model.message = JSON.parse(this.model.message);

        this.model.detect_cnt = 0
        this.model.block_cnt = 0

        _.forEach(this.model.message.messages, rule => {
          rule.is_info = rule.message.toLowerCase().indexOf('geoip') > -1

          if(!rule.is_info && this.model.is_block) {
            rule.is_detect = _.startsWith(rule.message.toLowerCase(), '[detectiononly]')
            rule.is_detect ? (this.model.detect_cnt += 1) : (this.model.block_cnt += 1)
          }
        })

        if(this.model.message.messages) {
          this.model.message.messages = _.sortBy(this.model.message.messages, ['is_detect', 'details.severity']).reverse()
        }
        if(!this.model.message.unique_id) { this.is_error = true }

        // console.log(this.model.message.messages[0].message)
        _.forEach(this.model.headers ? this.model.headers.split('\n') : [], line => {
          let ip = line.replace(/(x-forwarded-for:| )/ig, '')
          console.log('ip', _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip))
          _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip) ? (this.model.xff = ip) : ''
        })
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
      finally {
        this.loading = false
      }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params, from); } },
  created() { console.log('detect.detail.vue', 'created'); },
  destroyed() { console.log('detect.detail.vue', 'destroyed'); },
  mounted() {
    console.log('detect.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
